import {
    Flex,
    Rate,
    Table
} from 'antd';
import {
    useQuery
} from '@apollo/client';
import { useSelector } from "react-redux";
import { selectRestaurant } from '../../store/selectors/user.selector';
import { RETRIEVE_REVIEWS } from '../../apollo/query/review.query';
import { format } from 'date-fns';

const Reviews = () => {
    /** Retrieve the restaurant ID */
    const restaurant = useSelector(selectRestaurant);
    /** Request the list of subcategories */
    const { data } = useQuery(RETRIEVE_REVIEWS, { variables: { nIDRestaurant: restaurant?.nID } });

    const columns = [
        {
            title: 'Client',
            dataIndex: 'sCustomerName',
            key: 'sCustomerName',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: 'Comentari',
            dataIndex: 'sReview',
            key: 'sReview',
            render: (value: string, record: any) => (
                <Flex vertical gap={5}>
                    <span style={{ fontFamily: 'Roboto-Thin', fontSize: '0.75rem' }}> { format(new Date(record.dDate), 'dd-MM-yyyy') } </span>
                    <span style={{ fontFamily: 'Roboto-Light', fontSize: '0.9rem', maxWidth: 300 }}> { value } </span>
                </Flex>
            )
        },
        {
            title: 'Cambrer',
            dataIndex: 'sWaiterName',
            key: 'sWaiterName',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: 'Valoració',
            dataIndex: 'rating',
            key: 'rating',
            render: (value: number) => <Rate disabled value={value} />
        }
    ];
    
    return (
        <Flex vertical style={{ backgroundColor: 'white', height: '100%', padding: 10 }}>
            <Flex style={{ width: '100%' }}>
                <Table
                    columns={columns}
                    dataSource={data?.data}
                    rowKey={(record: any) => record.nID}
                    style={{ width: '100%' }}
                    pagination={false}
                />
            </Flex>
        </Flex>
    );
}

export default Reviews;